/* eslint-disable */
<template>
  <div class="AdminManageBookingRequest">
    <AdminNavigation ref="navigation" indexProps="1"/>
    <div class="top-panel">
      <Header/>
      <div class="header-title-section">
        <div class="header-title"><h1>Booking Request</h1></div>
        <div class="header-sub-title">We look forward to helping you arrange the service you require for your claimant.
          Please tell us about your requirements, so that we can find the right specialist for your needs.
        </div>
      </div>
    </div>
    <div class="panel">
      <AdminBookingsMenu indexProps="1"/>
      <div class="content">
        <!-- <div v-if="showCaseInfo" style="padding-left: 10px;">
          <span class="text-bold">Claimant:</span> {{ singleCase.claimantFullName }} <span class="text-bold"> D.O.B:</span> {{ formatDate(singleCase.dateOfBirth) }}
          <span class="text-bold"> Commencement Date: </span> {{ singleCase.commencementDate }} <span class="text-bold"> Referral Type:</span> {{getClaimType(singleCase.claimTypeId)}}
        </div> -->
        <div class="box booking-details">
          <div class="box-heading col-space-between">
            <div>Booking Request details</div>
          </div>
          <div class="box-body">
            <div class="box-row">
              <div class="box-col box-col-left required">Service Type</div>
              <div class="box-col box-col-right">
                <el-select @change="onChangeBookingType" filterable popper-class="search-specialty-popup" class="w-50" placeholder="Please choose" :class="hasError && bookingTypeError ? 'is-invalid' : ''"
                        v-model="bookingRequest.bookingTypeId">
                  <el-option v-for="bookingType in bookingTypes" :key="bookingType.id" :value="bookingType.id" :label="bookingType.name">
                    {{ bookingType.name }}
                  </el-option>
                </el-select>
                <span class="ml-3" style="color: #3FA2F7; cursor: pointer" @click="getTPDPopup" v-if="isTPD">What's TPD Assist?</span>
                <div v-if="hasError && bookingTypeError" class="text-danger">{{ bookingTypeError }}</div>
              </div>
            </div>
            <div class="box-row" v-if="isTPD" >
              <div class="box-col box-col-left required">Number of services</div>
              <div class="box-col box-col-right">
                <el-checkbox v-model="showMAS" @change="onChangeNum('MAS', $event)" class="default-checkbox tick">MAS</el-checkbox> <el-input-number v-show="showMAS" :controls="false" style="width: 50px" v-model="bookingRequest.MAS" controls-position="right" :min="1" step-strictly :max="10"></el-input-number>
                <el-checkbox v-model="showPIC" @change="onChangeNum('PIC', $event)" class="default-checkbox tick">PIC</el-checkbox> <el-input-number v-show="showPIC" :controls="false" style="width: 50px"  v-model="bookingRequest.PIC" controls-position="right" :min="1" step-strictly :max="10"></el-input-number>
                <el-checkbox v-model="showSHORT" @change="onChangeNum('ShortReport', $event)" class="default-checkbox tick">Short Report</el-checkbox> <el-input-number v-show="showSHORT" :controls="false" style="width: 50px"  v-model="bookingRequest.ShortReport" controls-position="right" step-strictly :min="1" :max="10"></el-input-number>
                <div v-if="hasError && numOfServicesError" class="text-danger pl-2">{{ numOfServicesError }}</div>
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left required">Referral Type</div>
              <div class="box-col box-col-right">
                <el-select :disabled="isTPD" filterable placeholder="Please choose type of claim..." popper-class="search-specialty-popup" class="w-50"
                           :class="hasError && claimTypeError ? 'is-invalid' : ''" v-model="bookingRequest.claimTypeId">
                  <el-option v-for="claimType in claimTypes" :value="claimType.id" :key="claimType.id" :label="claimType.name">{{ claimType.name }}</el-option>
                </el-select>
                <div v-if="hasError && claimTypeError" class="text-danger">{{ claimTypeError }}</div>
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left required">Client</div>
              <div class="box-col box-col-right">
                <el-select popper-class="search-specialty-popup" filterable clearable placeholder="Please choose client..." class="w-50"
                           :class="hasError && clientError ? 'is-invalid' : ''" v-model="bookingRequest.clientId" @change="changeClient">
                  <el-option v-for="client in clients" :value="client.id" :key="client.id" :label="client.fullName">{{ client.fullName }}</el-option>
                </el-select>
                <div v-if="hasError && clientError" class="text-danger">{{ clientError }}</div>
              </div>
            </div>
<!--            <div class="box-row">-->
<!--              <div class="box-col box-col-left" :class="isHideSpecialty ? 'disabled-element' : ''">Required Specialty, if known</div>-->
<!--              <div class="box-col box-col-right">-->
<!--                <el-select filterable class="w-50" placeholder="Please choose" popper-class="search-specialty-popup"  :class="hasError && !validateBookingRequest ? 'is-invalid' : ''"-->
<!--                        v-model="specialtyId" @change="changeSpecialty">-->
<!--                  <el-option v-for="(specialty, index) in qualifications" :key="specialty.id" :label="specialty.name" :value="specialty.id">{{-->
<!--                      specialty.name-->
<!--                    }}-->
<!--                  </el-option>-->
<!--                </el-select>-->
<!--                <div v-if="hasError && !validateBookingRequest" class="text-danger">Speciality or Specialist is-->
<!--                  required.-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
            <div class="box-row">
              <div class="box-col box-col-left" :class="!isHideSpecialty ? 'disabled-element' : ''">Choose Specialist</div>
              <div class="box-col box-col-right">
                <el-select class="w-50" popper-class="search-specialty-popup" filterable  placeholder="Please choose (optional)"
                        v-model="bookingRequest.specialistId" @change="changeSpecialist">
                  <el-option v-for="(specialist, index) in filteredSpecialists" :key="specialist.id" :label="specialist.fullName" :value="specialist.id">{{
                      specialist.fullName
                    }}
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="box-row" >
              <div class="box-col box-col-left required">Reference Number</div>
              <div class="box-col box-col-right">
                <input class="textbox" type="text"
                       v-model="bookingRequest.ClientReference"
                       placeholder="Reference Number"
                       maxlength="64"
                       @blur="trimField('ClientReference')" />
                <div v-if="hasError && clientReferenceError" class="text-danger">{{ clientReferenceError }}</div>
              </div>
            </div>
            <div class="box-row" >
              <div  class="box-col box-col-left required">State where the incident occurred</div>
              <div class="box-col box-col-right">
                <el-select v-model="bookingRequest.IncidentState" :class="hasError && incidentStateError ? 'is-invalid' : ''">
                  <el-option v-for="state in statesNew" :key="state.value" :value="state.value" :label="state.text">{{ state.text }}</el-option>
                </el-select>
                <div v-if="hasError && incidentStateError" class="text-danger">{{ incidentStateError }}</div>
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left required">Examinee</div>
              <div class="box-col box-col-right">
                <div class="is-icon">
                  <input @click="openAddNameModal" v-if="bookingRequest.claimantFullName.length == 0" readonly class="pl-3 w-50"
                         placeholder="Click to add Examinee"/>
                  <span @click="openAddNameModal" v-else class="padding-left-10">
                    {{ bookingRequest.claimantFullName }}
                  </span>
                </div>
                <div v-if="hasError && claimantNameErrors" class="text-danger">{{ claimantNameErrors }}</div>
              </div>
              <AdminAddNameModal ref="adminAddNameModal"/>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left required">Date of Birth</div>
              <div class="box-col box-col-right">
                <el-date-picker
                    v-model="bookingRequest.dateOfBirth"
                    :picker-options="pickerOptions"
                    type="date"
                    :class="['w-50']"
                    format="dd/MM/yyyy"
                    placeholder="Please select">
                </el-date-picker>
                <div v-if="hasError && dateOfBirthError" class="text-danger">{{ dateOfBirthError }}</div>
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left">Affected Body Areas</div>
              <div class="box-col box-col-right box-col-center">
                <vue-tags-input
                    v-model="bodyAreaTag"
                    :tags="bodyAreaTags"
                    placeholder="Add Affected Body Areas"
                    :autocomplete-items="filteredBodyAreaItems"
                    @tags-changed="(newTags) => (bodyAreaTags = newTags)"
                    @focus="openDigram()"
                />
                <div @click="openBodyDiagram">
                  <img src="@/assets/images/choose.svg" alt="" class="right-element align-self-center is-icon pr-3"
                       style="top:50%;margin-top:-18px;"/>
                </div>
                <AddBodyDiagramModal style="top: 0px" ref="addBodyDiagramModal"/>
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left">Other Body Areas</div>
              <div class="box-col box-col-right box-col-center">
                <vue-tags-input
                    v-model="otherBodyAreaTag"
                    :tags="otherBodyAreaTags"
                    placeholder="Add Other Body Areas"
                    @tags-changed="(newTags) => (otherBodyAreaTags = newTags)" />
                <div v-if="hasError && otherBodyAreasError" class="text-danger">{{ otherBodyAreasError }}</div>
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left">Conditions</div>
              <div class="box-col box-col-right box-col-center">
                <el-select  placeholder="Add Conditions" class="w-100" v-model="bookingRequest.PersonConditions" multiple clearable filterable>
                  <el-option v-for="item in personConditions" :value="item.value" :label="item.text" :key="item.value"></el-option>
                </el-select>
              </div>
            </div>
            <div v-if="!isTPD" class="box-row">
              <div class="box-col box-col-left required">Choose Region / Location</div>
              <div class="box-col box-col-right">
                <el-cascader
                    popper-class="search-no-scroll-panel"
                    class="w-50"
                    :options="regionLocations"
                    :value="locationValue"
                    @change="changeRegion"
                    :props="{ checkStrictly: true, value: 'id', label: 'label' }"
                    clearable>
                </el-cascader>
                <div v-if="hasError && locationError" class="text-danger">{{ locationError }}</div>
              </div>
            </div>
            <div v-if="!isTPD" class="box-row">
              <div class="box-col box-col-left required">Specify Date Range</div>
              <div class="box-col box-col-right">
                <el-date-picker
                    v-model="valueDate"
                    @change="changeDateRange"
                    :picker-options="pickerOptions1"
                    type="daterange"
                    start-placeholder="Start Date"
                    end-placeholder="End Date"
                    :default-time="['00:00:00', '23:59:59']">
                </el-date-picker>
                <div class="text-danger" v-if="hasError && dateRangeError">{{ dateRangeError }}</div>
              </div>
            </div>
            <div class="box-row" v-if="showDelivery" >
              <div class="box-col box-col-left required">Delivery Method</div>
              <div class="box-col box-col-right">
                <el-select filterable multiple clearable placeholder="Select delivery method"
                           class="w-50" v-model="bookingRequest.deliveryMethod">
                  <el-option :value="2" label="Virtual"
                             title="This service will be delivered by videolink only."></el-option>
                  <el-option :value="1" label="In-Person"
                             title="This service will be delivered face to face with the Medical Expert"></el-option>
                </el-select>
                <div class="text-danger" v-if="hasError && deliveryMethodError">{{ deliveryMethodError }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="box-heading tab">
            <div class="tab-heading" @click="openTab(0)">Notes</div>
            <div class="tab-heading" @click="openTab(1)">Files</div>
            <div class="right-element">
              <v-btn class="add-icon" dark @click="openAddNew">Add New</v-btn>
              <AdminAddNoteModal ref="adminAddNoteModal"/>
            </div>
          </div>
          <div class="box-body tab-content hidden-element">
            <div v-if="bookingRequest.note != ''" class="box-row is-icon" @click="openAddNoteModal">
              <div class="box-col">{{ user.name }}</div>
              <div class="box-col">{{ getCurrentDate() }}</div>
              <div class="box-col">
                {{ bookingRequest.note }}
              </div>
            </div>
          </div>
          <div class="box-body tab-content hidden-element">
            <div>
              <div class="content-scroll-y" style="height:auto;max-height:460px;">
                <table class="table remove-min-height">
                  <tbody>
                  <tr v-for="(file, index) in filelist" class="py-0">
                    <th style="width:90%" class="long-text"><a :href="file.url" target="blank">{{ file.name }}</a></th>
                    <th style="width:10%" class="icon-col">
                      <div class="icon-group box-date-time-end">
                        <img src="@/assets/images/delete_icon.svg" @click="deleteFile(index)"/>
                      </div>
                    </th>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="file-upload-area border-gray-300 mt-5" @dragover="dragover" @dragleave="dragleave" @drop="drop">
              <input
                  type="file"
                  multiple
                  name="fields[assetsFieldHandle][]"
                  id="assetsFieldHandle"
                  class="w-px h-px opacity-0 overflow-hidden absolute"
                  @change="onChange"
                  ref="file"
                  accept=""/>
              <label for="assetsFieldHandle" class="block cursor-pointer d-flex flex-column align-items-center justify-content-center">
                <div>Drop files in this area or <span style="text-decoration:underline"
                                                      class="is-icon">click here</span> to upload files.
                </div>
                <div>Files over 200MB in file size may cause errors. If you need to upload files of this size, please contact us on 1300 100 733</div>
              </label>
            </div>
          </div>
        </div>
        <div class="alert alert-success hidden-element">
          <a class="close" title="close">×</a>
          <b>Success:</b> {{ successMessage }}
        </div>
        <div class="alert alert-danger hidden-element">
          <a class="close" title="close">×</a>
          <b>Error:</b> {{ errorMessage }}
        </div>

        <div class="box-row item-right box-col-next">
          <div>
            <v-btn dark @click="submit()">Submit</v-btn>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="Information about TPD Assist" :visible.sync="tpdList">
      <div class="mt-2" style="word-break: break-word"  v-html="tpdList && tpdList.Message">
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="cancelTPDModal">OK</el-button>
  </span>
    </el-dialog>
    <TPDFiles :client="false" :fileCountList="fileCountList" :tpdFilesDialog="tpdFilesDialog" @cancelDialog="tpdFilesDialog = false" @next="handleFiles" />
  </div>
</template>

<script>
import utilities from '@/assets/js/utilities'
import AdminNavigation from '@/components/AdminNavigation'
import AdminBookingsMenu from '@/components/AdminBookingsMenu'
import Header from '@/components/Header'
import AdminAddNameModal from '@/components/AdminAddNameModal'
import AdminAddNoteModal from '@/components/AdminAddNoteModal'
import AddBodyDiagramModal from '@/components/AddBodyDiagramModal'
import TPDFiles from "./TPDFiles.vue";

export default {
  name: 'AdminManageBookingRequest',
  components: {
    TPDFiles,
    AdminNavigation,
    AdminBookingsMenu,
    Header,
    AdminAddNameModal,
    AdminAddNoteModal,
    AddBodyDiagramModal
  },
  data() {
    return {
      statesNew: utilities.getStates(),
      tpdList: null,
      fileCountList: [0, 0, 0, 0],
      tpdFilesDialog: false,
      showSHORT: false,
      showMAS: false,
      showPIC: false,
      locationValue: null,
      valueDate: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      hasError: false,
      isNewClaimant: false,
      successMessage: '',
      errorMessage: '',
      caseOwner: '',
      isHideSpecialty: true,
      bookingRequest: utilities.initBookingRequest(),
      specialtyId: '',
      singleCase: utilities.initCase(),
      otherBodyAreaTags: [],
      bookingTypes: [],
      claimTypes: [],
      clients: [],
      cases: [],
      showDelivery: false,
      qualifications: [],
      specialists: [],
      filteredSpecialists: [],
      regions: [],
      locations: [],
      regionLocations: [],
      fileTypes: [],
      otherBodyAreaTag: "",
      bodyAreas: [],
      bodyAreaTag: '',
      bodyAreaTags: [],
      personConditions: [],
      personConditionTag: '',
      personConditionTags: [],
      filelist: [],
      clientContacts: [],

    }
  },
  computed: {
    user() {
      return this.$store.getters['user/getUser'];
    },
    isTPD() {
      return this.bookingRequest.bookingTypeId === 19
    },
    bookingTypeError() {
      if (this.bookingRequest.bookingTypeId === '' || this.bookingRequest.bookingTypeId === null || this.bookingRequest.bookingTypeId === undefined) {
        return 'Service type is required.'
      }
      return ''
    },
    claimTypeError() {
      if (this.bookingRequest.claimTypeId === '' || this.bookingRequest.claimTypeId === null || this.bookingRequest.claimTypeId === undefined) {
        return 'Referral type is required.'
      }
      return ''
    },
    clientError() {
      if (this.bookingRequest.clientId === '' || this.bookingRequest.clientId === null || this.bookingRequest.clientId === undefined) {
        return 'Client is required.'
      }
      return ''
    },
    clientReferenceError() {
      return utilities.getBookingRequestReferenceError(this.bookingRequest.ClientReference)
    },
    incidentStateError() {
      if (!this.bookingRequest.IncidentState || String(this.bookingRequest.IncidentState).trim() === '') {
        return 'State where the incident occurred is required.'
      }
      return ''
    },
    claimantNameErrors() {
      return [
        utilities.getClientContactPersonNameError(this.bookingRequest.claimantFirstName, 'First name'),
        utilities.getClientContactMiddleNameError(this.bookingRequest.claimantGivenNames),
        utilities.getClientContactPersonNameError(this.bookingRequest.claimantSurname, 'Surname'),
      ].filter(Boolean).join(' ')
    },
    dateOfBirthError() {
      if (this.bookingRequest.dateOfBirth === '' || this.bookingRequest.dateOfBirth === null || this.bookingRequest.dateOfBirth === undefined) {
        return 'Date of birth is required.'
      }
      return ''
    },
    locationError() {
      if (this.isTPD) return ''
      if (!this.bookingRequest.regionId && !this.bookingRequest.stateId) {
        return 'Region / location is required.'
      }
      return ''
    },
    /** Optional per spec; validate only when a range is partially selected. */
    dateRangeError() {
      if (this.isTPD) return ''
      if (!this.valueDate || this.valueDate.length === 0) return ''
      if (this.bookingRequest.dateFrom && this.bookingRequest.dateTo) return ''
      return 'Please specify a complete date range (start and end).'
    },
    numOfServicesError() {
      if (!this.isTPD) return ''
      if (!this.showSHORT && !this.showMAS && !this.showPIC) {
        return 'Please select at least one service type (MAS, PIC, or Short Report) and enter a number.'
      }
      if ((this.showSHORT && !this.bookingRequest.ShortReport) || (this.showMAS && !this.bookingRequest.MAS) || (this.showPIC && !this.bookingRequest.PIC)) {
        return 'Please enter a number (1–10) for each selected service type.'
      }
      return ''
    },
    deliveryMethodError() {
      if (!this.showDelivery) return ''
      const dm = this.bookingRequest.deliveryMethod
      if (!dm || (Array.isArray(dm) && dm.length === 0)) {
        return 'Please select at least one delivery method.'
      }
      return ''
    },

    otherBodyAreasError() {
      return utilities.getBookingRequestOtherBodyAreasError(this.otherBodyAreaTags)
    },
    contactError() {
      if (this.isNewClaimant && this.caseOwner === '') {
        return 'Please complete the case owner field.'
      }
      return ''
    },
    filteredBodyAreaItems() {
      return this.bodyAreas.filter((i) => {
        return i.text.toLowerCase().indexOf(this.bodyAreaTag.toLowerCase()) !== -1
      })
    },
    filteredPersonConditionsItems() {
      return this.personConditions.filter((i) => {
        return i.text.toLowerCase().indexOf(this.personConditionTag.toLowerCase()) !== -1
      })
    },
  },
  methods: {
    cancelTPDModal() {
      this.tpdList = null
    },
    getTPDPopup() {
      this.$store.dispatch('loading/setLoadComponent', true)
      utilities.getTPDPopUp().then(res => {
        this.tpdList = res
        this.$store.dispatch('loading/setLoadComponent', false)
      })
    },
    handleFiles(files) {
      this.tpdFilesDialog = false
      this.openTab(1)
      //this.booking.bookingFiles = []
      var i = 0
      const fileTypes = ['MAS Template', 'PIC Template', 'Letter of Instruction', 'Brief']
      files.map((e, index) => {
        e && e.forEach((x) => {
          let file = this.filelist.filter((y) => y.name === x.name)
          if (file.length === 0) {
            x.FileTypeID =  this.fileTypes.find((x) => x.FileTypeName === fileTypes[index]).FileTypeID,
            this.filelist.push(
               x
            )
          }
        })
      })
      console.log(this.filelist)
    },
    checkValidFilesForTPD() {
      const fileTypes = ['MAS Template', 'PIC Template', 'Letter of Instruction', 'Brief']
      const fileCounts = [this.showMAS ? this.bookingRequest.MAS : 0, this.showPIC ?this.bookingRequest.PIC : 0, this.showSHORT ? this.bookingRequest.ShortReport : 0, 1]
      let valid = true
      fileTypes.forEach((file, i) => {
        const id = this.fileTypes.find((x) => x.FileTypeName === file).FileTypeID
        const filter = this.filelist.filter(x => x.FileTypeID === id)
        if(filter.length < fileCounts[i] && file !== 'Brief') {
          this.fileCountList[i] = fileCounts[i] - filter.length
          valid = false
        } else if (file === 'Brief' && filter.length === 0) {
          this.fileCountList[i] = 1
          valid = false
        } else {
          this.fileCountList[i] = 0
        }
      })
      return valid
    },
    onChangeNum(name, value) {
      if (value) {
        this.bookingRequest[name] = 1
        this.$set(this.bookingRequest, name, 1)
      } else {
        this.$set(this.bookingRequest, name, 0)
      }
    },
    openDigram() {
      this.openBodyDiagram()
    },

    onChangeBookingType() {
      this.showDelivery = utilities.bookingTypeWithDeliveryMethods(this.bookingRequest.bookingTypeId)
      if(this.bookingRequest.bookingTypeId === 19) {
        this.bookingRequest.claimTypeId = 3
        this.getTPDPopup()
      } else {
        this.bookingRequest.claimTypeId = null
      }
    },

    openBodyDiagram() {
      this.$refs.addBodyDiagramModal.handleModal()
      this.$refs.addBodyDiagramModal.filteredBodyAreas = this.bodyAreas
      this.$refs.addBodyDiagramModal.bodyAreas = _.cloneDeep(this.bodyAreaTags)
      this.$refs.addBodyDiagramModal.handleClick()
    },

    setBodyArea(addedBodyAreas) {
      this.bodyAreaTags = []
      this.bodyAreaTags = addedBodyAreas
    },

    deleteBodyAreaItems() {
    },

    formatDate(dateOfBirth, newFormat) {
      return utilities.formatDate(dateOfBirth, newFormat)
    },
    getCurrentDate() {
      return moment().format('DD/MM/YYYY hh:mm A')
    },
    openFilesBox() {
      $('#assetsFieldHandle').trigger('click')
    },
    openTab(index) {
      utilities.openTab(index)
    },
    openAddNew() {
      if ($(".tab-content").eq(0).is(":visible")) this.openAddNoteModal()
      else this.openAddFile()
    },
    openAddNoteModal() {
      if (this.bookingRequest.note != '') this.$refs.adminAddNoteModal.loadNote(this.bookingRequest.note)
      this.$refs.adminAddNoteModal.handleModal()
    },
    openAddFile() {
      $('#assetsFieldHandle').trigger('click')
    },
    openAddNameModal() {
      this.$refs.adminAddNameModal.cases = this.cases
      if (this.bookingRequest.claimantFullName != '') this.$refs.adminAddNameModal.loadName(this.bookingRequest)
      this.$refs.adminAddNameModal.handleModal()
    },
    changeRegion(item) {
      console.log(item)
      if (item && item.length > 0) {
        this.$set(this.bookingRequest, 'stateId', item[0])
        if (item.length > 1) {
          this.$set(this.bookingRequest, 'regionId', item[1])
        }
      } else {
        this.bookingRequest.regionId = null;
        this.bookingRequest.stateId = null
      }
      this.$forceUpdate()
    },
    async changeClient() {
      this.$store.dispatch('loading/setLoadComponent', true)
      this.bookingRequest.caseId = ""
      const {clientCase} =  await utilities.getCasesNew({ClientID: this.bookingRequest.clientId, pageSize: 999})
      this.cases = clientCase
      this.cases.sort((a, b) => {
        return a.claimantFullName > b.claimantFullName ? 1 : -1
      })
      this.$store.dispatch('loading/setLoadComponent', false)
    },
    changeSpecialty() {
      this.bookingRequest.specialistId = ""
      this.isHideSpecialty = false
    },
    changeSpecialist() {
      this.specialtyId = ""
      this.isHideSpecialty = true
    },
    loadName(name) {
      this.bookingRequest.caseId = name.caseId
      this.bookingRequest.claimantFirstName = name.firstName
      this.bookingRequest.claimantGivenNames = name.middleName
      this.bookingRequest.claimantSurname = name.surname
      this.bookingRequest.claimantFullName = utilities.getClaimantFullName(this.bookingRequest)
      this.bookingRequest.dateOfBirth = name.dateOfBirth
    },
    loadNote(note) {
      this.bookingRequest.note = note
    },
    changeDateRange(item) {
      console.log(item)
      this.bookingRequest.dateFrom = utilities.formatDate(item[0])
      this.bookingRequest.dateTo = utilities.formatDate(item[1])
    },
    async onChange() {
      this.filelist = [...this.filelist, ...this.$refs.file.files]
    },
    deleteFile(index) {
      this.filelist.splice(index, 1)
    },
    dragover(event) {
      event.preventDefault()
      event.currentTarget.classList.add('dark-border-hover')
    },
    dragleave(event) {
      event.currentTarget.classList.remove('dark-border-hover')
    },
    drop(event) {
      event.preventDefault()
      this.$refs.file.files = event.dataTransfer.files
      this.onChange() // Trigger the onChange event manually
      // Clean up
      event.currentTarget.classList.add('bg-gray-100')
      event.currentTarget.classList.remove('bg-green-300')
      event.currentTarget.classList.remove('dark-border-hover')
    },
    async getLocationData() {
      var locations = await utilities.getLocations()
      var groupedLocations = []
      locations.map((x) => {
        if (groupedLocations[x.regionId] == undefined) {
          groupedLocations[x.regionId] = []
        }
        groupedLocations[x.regionId].push(x)
      })
      var tempLocations = []
      groupedLocations.map((x) => {
        var obj = {
          id: 'r' + x[0].regionId,
          label: x[0].regionName,
        }
        var children = []
        for (var i = 0; i < x.length; i++) {
          children.push({
            id: 'c' + x[i].cityId,
            label: x[i].cityName,
          })
        }
        children = _.uniqBy(children, 'label')
        obj.children = children
        tempLocations.push(obj)
      })
      this.locations = tempLocations
    },
    sanitizeBookingRequest() {
      this.bookingRequest.ClientReference = String(this.bookingRequest.ClientReference || '').trim()
      this.bookingRequest.claimantFirstName = String(this.bookingRequest.claimantFirstName || '').trim()
      this.bookingRequest.claimantGivenNames = String(this.bookingRequest.claimantGivenNames || '').trim()
      this.bookingRequest.claimantSurname = String(this.bookingRequest.claimantSurname || '').trim()
      this.bookingRequest.note = String(this.bookingRequest.note || '').trim()
    },
    trimField(prop) {
      const v = this.bookingRequest[prop]
      if (v === undefined || v === null) return
      this.bookingRequest[prop] = String(v).trim()
    },
    async submit() {
      this.sanitizeBookingRequest()
      const validationErrors = [
        this.bookingTypeError,
        this.claimTypeError,
        this.clientError,
        this.clientReferenceError,
        this.incidentStateError,
        this.claimantNameErrors,
        this.dateOfBirthError,
        this.locationError,
        this.dateRangeError,
        this.otherBodyAreasError,
        this.numOfServicesError,
        this.deliveryMethodError,
        this.contactError,
      ].filter(Boolean)
      if (validationErrors.length > 0) {
        this.hasError = true
        this.errorMessage = "Please correct the errors shown above and try again."
        utilities.showAlert(".alert-danger")
        return
      }
      this.hasError = false

      if(this.isTPD && !this.checkValidFilesForTPD()) {
        this.$forceUpdate()
        this.tpdFilesDialog = true
        return
      }

      await this.$store.dispatch('loading/setLoadComponent', true)
      var result = await this.postBookingRequest()
      if (result) {
        if (this.filelist.length > 0) {
          let item = []
          await Promise.all(this.filelist.map(async (x) => {
            if (this.bookingRequest.id != '') {
              var fileName = window.moment().unix() + '_' + x.name.replace(/\s/g, '_')
              const mimeType = await utilities.getFileMimeType(x, x.type || 'application/octet-stream')
              var fileParams = {
                fn: fileName,
                ft: mimeType,
                id: this.bookingRequest.id,
                FileTypeID: x.FileTypeID ? x.FileTypeID : 5,
              }
              var result = await utilities.postRequestPreSign(fileParams)
              var postData = new FormData();

              for (var key in result.fields) {
                postData.append(key, result.fields[key]);
              }
              postData.append('file', x)
              const r = await utilities.postImage(result.url, postData)
              if(r) {
                item.push({
                  BookingRequestID: this.bookingRequest.id,
                  DateUploaded: window.moment().format('YYYY-MM-DD HH:mm:ss'),
                  FileName: fileName,
                  MimeType: mimeType,
                  FileTypeID: x.FileTypeID ? x.FileTypeID : 5,
                  UploadedBy: this.user.id,
                  UploadedByName: this.user.name
                })
              }
            }
          }))
          if(item.length > 0) {
            await utilities.postRequestFileRecord(item)
          }
        }
        this.successMessage = 'Your Booking Request has been added.'
        utilities.showAlert('.alert-success')
        setTimeout(() => {
          this.$router.push({name: 'admin-booking-requests', params: {}})
        }, 2000)
      }
      this.$store.dispatch('loading/setLoadComponent', false)
    },

    postBookingRequest() {
      var bodyAreaObjects = []
      var bodyArea = {}
      if (this.bodyAreaTags.length > 0) {
        this.bodyAreaTags.map((x) => {
          bodyArea = {
            BodyAreaID: x.value,
          }
          bodyAreaObjects.push(bodyArea)
        })
      }


      var qualifications = []
      var qualification = {}
      if (this.specialtyId) {
        qualification = {
          QualificationID: this.specialtyId,
        }
        qualifications.push(qualification)
      }

      var params = {
        MAS: this.showMAS ? this.bookingRequest.MAS : 0,
        PIC: this.showPIC ? this.bookingRequest.PIC : 0,
        ShortReport: this.showSHORT ? this.bookingRequest.ShortReport : 0,
        CaseID: this.bookingRequest.caseId,
        ClientID: this.bookingRequest.clientId,
        SpecialistID: this.bookingRequest.specialistId,
        BookingTypeID: this.bookingRequest.bookingTypeId,
        ClaimTypeID: this.bookingRequest.claimTypeId,
        DateFrom: this.bookingRequest.dateFrom,
        DateTo: this.bookingRequest.dateTo,
        ClientReference: this.bookingRequest.ClientReference,
        IncidentState: this.bookingRequest.IncidentState,
        VideoLinkAccepted: utilities.convertBoolToNum(this.bookingRequest.videoLinkAccepted),
        BookingRequestStatus: 1,
        ClaimantFirstName: this.bookingRequest.claimantFirstName,
        ClaimantGivenNames: this.bookingRequest.claimantGivenNames,
        ClaimantSurname: this.bookingRequest.claimantSurname,
        DateofBirth: this.formatDate(this.bookingRequest.dateOfBirth, 'YYYY-MM-DD'),
        Notes: this.bookingRequest.note,
        BodyAreaObject: bodyAreaObjects,
        ConditionObject: this.bookingRequest.PersonConditions.map(item => {return {PersonConditionID: item}}),
        DateSubmitted: moment().format('YYYY-MM-DD HH:mm:ss'),
        DeliveryMethodIDs: this.bookingRequest.deliveryMethod ? this.bookingRequest.deliveryMethod : undefined,
      }
      if (this.bookingRequest.stateId && this.bookingRequest.stateId.includes('s')) {
        params.StateID = Number(this.bookingRequest.stateId.replace('s', ''))
      }
      if (this.bookingRequest.regionId && this.bookingRequest.regionId.includes('r')){
        params.RegionID = Number(this.bookingRequest.regionId.replace('r', ''))
      }
      let otherBodyArea = ""
      this.otherBodyAreaTags.map((x) => {
        if (otherBodyArea == "") {
          otherBodyArea = x.text
        } else {
          otherBodyArea = otherBodyArea + "," + x.text
        }
      })
      params.BodyAreaOther = otherBodyArea

      let obj = {...params}
      for (let key in obj) {
        if (obj[key] === null || obj[key] === '') {
          delete obj[key];
        }
      }
      var callback = (response) => {
        this.bookingRequest.id = response
      }
      console.log(obj)
      return utilities.postBookingRequest(obj, callback)
    },
    loadData() {
      const result = this.$store.getters['bookingRequest/getBookingObject']
      if(result) {
        this.bookingRequest.specialistId = result.specialistId
        if (result.StateID) {
          this.locationValue = []
          this.bookingRequest.stateId = result.StateID
          this.locationValue.push(this.bookingRequest.stateId)
          if (result.regionId) {
            this.bookingRequest.regionId = result.regionId
            this.locationValue.push(this.bookingRequest.regionId)
          }
        }
        this.valueDate = [result.startDate, result.endDate]
        this.changeDateRange(this.valueDate)
        this.bookingRequest.deliveryMethod = result.deliveryMethod
        this.bookingRequest.bookingTypeId = result.bookingTypeID
        this.onChangeBookingType()
        this.$store.dispatch('bookingRequest/setBookingRequestObject', null)
      }
      const promiseArr = [utilities.getBookingTypes(), utilities.getClaimTypes(), utilities.getClients(), utilities.getQualifications(), utilities.getSpecialists(), utilities.getBodyArea(), utilities.getPersonConditions(), utilities.getRegions(), utilities.getLocations(), utilities.getFileTypes()]
      Promise.all(promiseArr).then(r => {
        const bookingTypes = r[0]
        if(this.user.type < 3) {
          this.bookingTypes = bookingTypes.filter(item => item.settings.Client.AllowBookingRequest)
        } else {
          this.bookingTypes = bookingTypes.filter(item => item.settings.Specialist.AllowBookingRequest)
        }
        this.claimTypes = r[1]
        this.clients = r[2]
        this.qualifications = r[3]
        this.specialists = r[4]
        this.filteredSpecialists = r[4]
        const bodyAreas = r[5]
        this.bodyAreas = utilities.getAutoCompleteBodyAreaTags(bodyAreas)
        const personConditions = r[6]
        this.personConditions = utilities.getAutoCompleteTagsUpperCase(personConditions)
        this.regions = r[7]
        this.locations = r[8]
        this.regionLocations = utilities.getRegionLocations(this.regions, this.locations, true)
        const types = r[9]
        types.map((x) => {
          if (x.name != 'Travel Itinerary') {
            this.fileTypes.push(x)
          }
        })
        this.$store.dispatch('loading/setLoadComponent', false)
      })
    },
  },
  async beforeMount() {
    this.$store.dispatch('loading/setLoadComponent', true)
    $('body>.tooltip').remove()
    this.loadData()
    this.openTab(0)
  },
  mounted() {
  },
}
</script>

<style scoped>
.search-popup-longer .el-select-dropdown__wrap {
  max-height: 330px;
}
.default-checkbox.tick {
  margin-left: 20px;
  margin-right: 20px;
  height: 40px;
}
::v-deep .el-input-number .el-input__inner {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>
